function CoinIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.4287 12C21.4287 17.6807 18.3587 22.2857 14.5716 22.2857H9.42871V1.71429C9.42871 1.71429 10.7845 1.71429 14.5716 1.71429C18.3587 1.71429 21.4287 6.31937 21.4287 12Z'
        fill='#FFD412'
        stroke='#FFE77C'
      />
      <path
        d='M17.1429 20.7285L17.6429 20.7285L17.6429 19.7285L17.1429 19.7285L17.1429 20.7285ZM12 20.7285L17.1429 20.7285L17.1429 19.7285L12 19.7285L12 20.7285Z'
        fill='#FFE77C'
      />
      <path
        d='M18.8572 19.0828L19.3572 19.0828L19.3572 18.0828L18.8572 18.0828L18.8572 19.0828ZM13.7144 19.0828L18.8572 19.0828L18.8572 18.0828L13.7144 18.0828L13.7144 19.0828Z'
        fill='#FFE77C'
      />
      <path
        d='M19.7144 17.4371L20.2144 17.4371L20.2144 16.4371L19.7144 16.4371L19.7144 17.4371ZM14.5715 17.4371L19.7144 17.4371L19.7144 16.4371L14.5715 16.4371L14.5715 17.4371Z'
        fill='#FFE77C'
      />
      <path
        d='M20.5713 15.7914L21.0713 15.7914L21.0713 14.7914L20.5713 14.7914L20.5713 15.7914ZM15.4285 15.7914L20.5713 15.7914L20.5713 14.7914L15.4285 14.7914L15.4285 15.7914Z'
        fill='#FFE77C'
      />
      <path
        d='M20.5713 14.1457L21.0713 14.1457L21.0713 13.1457L20.5713 13.1457L20.5713 14.1457ZM15.4285 14.1457L20.5713 14.1457L20.5713 13.1457L15.4285 13.1457L15.4285 14.1457Z'
        fill='#FFE77C'
      />
      <path
        d='M20.5713 12.5L21.0713 12.5L21.0713 11.5L20.5713 11.5L20.5713 12.5ZM15.4285 12.5L20.5713 12.5L20.5713 11.5L15.4285 11.5L15.4285 12.5Z'
        fill='#FFE77C'
      />
      <path
        d='M20.5713 10.8542L21.0713 10.8542L21.0713 9.85425L20.5713 9.85425L20.5713 10.8542ZM15.4285 10.8542L20.5713 10.8542L20.5713 9.85425L15.4285 9.85425L15.4285 10.8542Z'
        fill='#FFE77C'
      />
      <path
        d='M20.5713 9.20856L21.0713 9.20856L21.0713 8.20856L20.5713 8.20856L20.5713 9.20856ZM15.4285 9.20856L20.5713 9.20856L20.5713 8.20856L15.4285 8.20856L15.4285 9.20856Z'
        fill='#FFE77C'
      />
      <path
        d='M19.7144 7.56281L20.2144 7.56281L20.2144 6.56281L19.7144 6.56281L19.7144 7.56281ZM14.5715 7.56281L19.7144 7.56281L19.7144 6.56281L14.5715 6.56281L14.5715 7.56281Z'
        fill='#FFE77C'
      />
      <path
        d='M18.8572 5.91711L19.3572 5.91711L19.3572 4.91711L18.8572 4.91711L18.8572 5.91711ZM13.7144 5.91712L18.8572 5.91711L18.8572 4.91711L13.7144 4.91712L13.7144 5.91712Z'
        fill='#FFE77C'
      />
      <path
        d='M18 4.27142L18.5 4.27142L18.5 3.27142L18 3.27142L18 4.27142ZM12.8572 4.27142L18 4.27142L18 3.27142L12.8572 3.27142L12.8572 4.27142Z'
        fill='#FFE77C'
      />
      <path
        d='M12.0001 21.4629H14.5715C17.8852 21.4629 20.5715 17.2262 20.5715 12C20.5715 6.77384 17.8852 2.53717 14.5715 2.53717H11.5715'
        stroke='#FFDC41'
      />
      <path
        d='M11.1431 21.4628C14.4568 21.4628 17.1431 17.2262 17.1431 12C17.1431 6.77377 14.4568 2.53711 11.1431 2.53711'
        stroke='#F1CD30'
      />
      <path
        d='M16.2858 12C16.2858 17.6807 13.2158 22.2857 9.42868 22.2857C5.64158 22.2857 2.57153 17.6807 2.57153 12C2.57153 6.31937 5.64158 1.71429 9.42868 1.71429C13.2158 1.71429 16.2858 6.31937 16.2858 12Z'
        fill='#FFEA8C'
        stroke='#FFD931'
      />
      <path
        d='M9.42871 21.4628C6.115 21.4628 3.42871 17.2262 3.42871 12C3.42871 6.77377 6.115 2.53711 9.42871 2.53711'
        stroke='#EFC81B'
      />
      <path
        d='M15.4287 12C15.4287 14.5783 14.7749 16.9158 13.7144 18.6226M13.9072 5.70239C14.3803 6.53875 14.7607 7.50848 15.0228 8.57139'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.2079 5.82861L10.9952 10.3773H13.5428L11.4817 13.1885L12.269 17.7371L10.2079 14.9259L8.14684 17.7371L8.9341 13.1885L6.87304 10.3773H9.42065L10.2079 5.82861Z'
        stroke='white'
        strokeLinejoin='round'
      />
      <path
        d='M8.64956 5.82861L9.43682 10.3773H11.9844L9.92337 13.1885L10.7106 17.7371L8.64956 14.9259L6.58849 17.7371L7.37575 13.1885L5.31469 10.3773H7.8623L8.64956 5.82861Z'
        stroke='#EAC10A'
        strokeLinejoin='round'
      />
      <path
        d='M9.42886 5.82861L10.2161 10.3773H12.7637L10.7027 13.1885L11.4899 17.7371L9.42886 14.9259L7.36779 17.7371L8.15505 13.1885L6.09398 10.3773H8.6416L9.42886 5.82861Z'
        fill='#FFD932'
        stroke='#FFD932'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export { CoinIcon };
